import {
  QR_PROVIDER_FETCH_REQUEST,
  QR_PROVIDER_FETCH_REQUEST_SUCCESS,
  QR_PROVIDER_FETCH_REQUEST_FAILURE,
  QR_PROVIDER_CLEAN_REQUEST,
  QR_PROVIDER_ADD_REQUEST,
  QR_PROVIDER_ADD_REQUEST_SUCCESS,
  QR_PROVIDER_ADD_REQUEST_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},

  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const bannersReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case QR_PROVIDER_FETCH_REQUEST:
    case QR_PROVIDER_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case QR_PROVIDER_FETCH_REQUEST_SUCCESS:
    case QR_PROVIDER_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case QR_PROVIDER_FETCH_REQUEST_FAILURE:
    case QR_PROVIDER_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case QR_PROVIDER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default bannersReducer;
